import React from 'react';

import { VisuallyHiddenSpan } from 'zoomforth_codesbane_viewer/component_lib/visually_hidden.jsx';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const PoweredByZf_ViewerVersion1 = ()=> (
  <div className="powered-by-zf">
    <a href="https://zoomforth.com" target="_blank">
      <img src="https://d3jozdooylvm2p.cloudfront.net/images/zoomforth/powered_by_zf.png"/>
    </a>
  </div>
);

const PoweredByZf_ViewerVersion2 = ()=> (
  <div className="powered-by-zf">
    <a href="https://zoomforth.com" className="zf-external-link" target="_blank">
      <VisuallyHiddenSpan>
        Powered by Zoomforth
      </VisuallyHiddenSpan>
      <img src="https://d3jozdooylvm2p.cloudfront.net/images/zoomforth/powered_by_zf.png" alt="" />
      <span className="opens-in-external-view-wrapper">
        Opens in a new window
      </span>
    </a>
  </div>
);

const PoweredByZf = (props)=> (
  <SiteViewerVersionComponentSelector>
    <PoweredByZf_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <PoweredByZf_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default PoweredByZf;
